// Generated by Melange

import * as Buhta_components__LoadingDiv from "../../../../../../../packages/components/src/atoms/LoadingDiv.js";
import * as Buhta_core__GrpcState from "../../../../../../../packages/core/lib/GrpcState.js";
import * as Buhta_landing__ClassifierHeader from "../ClassifierHeader.js";
import * as Buhta_landing__ClassifiersKbkList from "./ClassifiersKbkList.js";
import * as Buhta_landing__ClassifiersKbkView from "./ClassifiersKbkView.js";
import * as Buhta_landing__Kbk from "../../../../grpc/Kbk.js";
import * as Buhta_landing__Route from "../../../../Route.js";
import * as Curry from "melange.js/curry.js";
import * as Stdlib__List from "melange/list.js";
import * as React from "react";
import * as JsxRuntime from "react/jsx-runtime";

function ClassifiersKbk(Props) {
  const currentRoute = Buhta_landing__Route.ofUrl(Buhta_landing__Route.useUrl(undefined));
  const func = Buhta_landing__Kbk.KbkService.grid;
  const match = Buhta_core__GrpcState.useModel((function (param) {
    return Curry._2(func, param, /* COUNTRY_KAZ */ 1);
  }), undefined);
  const dispatch = match[1];
  const grid = match[0];
  const kbks = typeof grid === "string" || grid.NAME !== "Data" ? /* [] */ 0 : Stdlib__List.sort((function (a, b) {
      if (a.code > b.code) {
        return 1;
      } else {
        return 0;
      }
    }), grid.VAL);
  React.useEffect((function () {
    Curry._2(dispatch, undefined, undefined);
  }), []);
  let tmp;
  if (typeof grid === "string") {
    tmp = grid === "Loading" ? JsxRuntime.jsx(Buhta_components__LoadingDiv.make, {}) : "Ошибка";
  } else if (grid.NAME === "Data") {
    if (/* tag */ typeof currentRoute === "number" || typeof currentRoute === "string" || currentRoute.TAG !== /* Landing */ 0) {
      tmp = null;
    } else {
      const match$1 = currentRoute._2;
      if (/* tag */ typeof match$1 === "number" || typeof match$1 === "string" || match$1.TAG !== /* Classifiers */ 8) {
        tmp = null;
      } else {
        const match$2 = match$1._0;
        if (/* tag */ typeof match$2 === "number" || typeof match$2 === "string" || match$2.TAG !== /* Kbk */ 1) {
          tmp = null;
        } else {
          const id = match$2._0;
          tmp = /* tag */ typeof id === "number" || typeof id === "string" ? JsxRuntime.jsx(Buhta_landing__ClassifiersKbkList.make, {
              kbks: kbks
            }) : JsxRuntime.jsx(Buhta_landing__ClassifiersKbkView.make, {
              kbks: kbks,
              id: id._0
            });
        }
      }
    }
  } else {
    tmp = "Ошибка";
  }
  return JsxRuntime.jsxs(React.Fragment, {
    children: [
      JsxRuntime.jsx(Buhta_landing__ClassifierHeader.make, {
        name: "КБК",
        title: "Коды бюджетной классификации",
        bg: "bg-secondary",
        darkText: false
      }),
      JsxRuntime.jsx("div", {
        children: tmp,
        className: "bg-white px-3 lg:px-10 py-5 lg:py-8 rounded-md h-[720px] lg:h-[632px] flex flex-col"
      })
    ]
  });
}

const make = ClassifiersKbk;

export {
  make,
}
/* Buhta_components__LoadingDiv Not a pure module */
